import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/kehutanan-web/kehutanan-web/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/kehutanan-web/kehutanan-web/src/components/gallery.comp.tsx");
